import React, { PureComponent } from "react";
import { goBack, push } from "react-router-redux";
import { connect } from "react-redux";
import Select from "react-select";
import classnames from "classnames";
import { Button, Tooltip } from "antd";
import { SingleDatePicker } from "react-dates";
import { TiWarningOutline } from "react-icons/ti";
import { selectLoggedAs } from "Selectors";
import moment from "moment";
import _ from "i18n";

import {
  setFilterCollaborators,
  setCapacityPlaningCollaborator,
  setCapacityPlaningCollaboratorTab
} from "Actions";
import {
  isManagerAccess,
  isCollaboratorAccess,
  isAdminAccess,
  isSuperAdminAccess
} from "Utils";

import TTPTab from "../Common/TTPTab";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { FilterIcon, SvgIcon, ICONS } from "../Common/Icons";
import SettingPageHeader from "../Common/PageHeader/SettingPageHeader";
import CollaboratorSpace from "../CollaboratorSpace/CollaboratorSpace";
import CollaboratorCalendarContainer from "./CollaboratorCalendarContainer";
import CapacityPlaningCollaboratorFinancials from "./CapacityPlaningCollaboratorFinancials";
import GroupedCapacityPlaningClients from "./GroupedCapacityPlaningClients/GroupedCapacityPlaningClients";

import styles from "./CapacityPlaning.local.scss";
import CollaboratorApi from "../../services/CollaboratorServices";

let tabs = [
  {
    id: "COLLABORATOR_SPACE",
    label: "Espace collaborateur"
  },
  {
    id: "CALENDAR",
    label: "Calendar"
  },
  {
    id: "MODEL_ALL_CLIENTS",
    label: "Capacity dossier"
  },
  {
    id: "FINANCIAL",
    label: "etat financier personnel"
  }
];

class CapacityPlaningCollaborator extends PureComponent {
  //******************   Content Functions  **************//

  constructor(props) {
    super(props);

    this.state = {
      collaborators: [],
      collaborator: null,
      loadingCollaborators: false,
      loadingCollaborator: false,
      fetchedCollaborator: false,
      filterFormIsVisible: false,
      arrowLeft: false,
      arrowRight: false,
      arrowPosition: 0,
      loading: false,
      analyseDate: props.date ? props.date : moment(),
      selectedYear: new Date().getFullYear().toString()
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideCollaboratorFilter.bind(this)
    );
    const { analyseDate } = this.state;
    this.setState({
      selectedYear: analyseDate
        ? analyseDate.format("Y")
        : new Date().getFullYear().toString()
    });

    this.handleArrowRightAndLeft();
    this.setState({
      loadingCollaborators: true,
      loadingCollaborator: true
    });
    this.loadCollaboratorSuggestions();
    this.loadCollaborator();
  }

  // //******************   Content Functions END  **************//

  //******************   Content Render functions  ****************//

  loadCollaboratorSuggestions = () => {
    const { organization } = this.props;
    CollaboratorApi.getCollaborators(organization.id)
      .then(response => {
        const collaborators = response.map(t => {
          return {
            value: t.id,
            label: t.name,
            color: "#000000"
          };
        });
        this.setState({
          collaborators: collaborators,
          loadingCollaborators: false
        });
      })
      .catch(error => {
        this.setState({
          error: error.response.data.errors[0],
          loadingCollaborators: false
        });
      });
  };

  loadCollaborator = () => {
    const { organization, collaboratorId } = this.props;
    CollaboratorApi.getCollaborator(organization.id, collaboratorId)
      .then(response => {
        let collaboratorResponse = {
          ...response.data.data,
          arrivalDate: response.data.data.arrivalDate
            ? moment(response.data.data.arrivalDate, "YYYY-MM-DD hh:mm:ss")
            : null
        };
        this.setState({
          collaborator: collaboratorResponse,
          fetchedCollaborator: true,
          loadingCollaborator: false
        });
        this.props.dispatch(
          setCapacityPlaningCollaborator({
            id: collaboratorResponse.id,
            name: collaboratorResponse.name
          })
        );
      })
      .catch(error => {
        this.setState({
          error: error.response.data.errors[0],
          fetchedCollaborator: false,
          loadingCollaborator: false
        });
      });
  };

  // renderCapacityPlanningTitle functions
  renderCapacityPlanningTitle = () => {
    //filter
    const { loggedAs, spaceAs } = this.props;
    const { collaborator, filterFormIsVisible, analyseDate } = this.state;

    let warningDate =
      collaborator &&
      collaborator.arrivalDate &&
      collaborator.arrivalDate.format("Y-MM-DD") > analyseDate.format("Y-01-01")
        ? collaborator.departureDate &&
          typeof collaborator.departureDate === Date &&
          collaborator.departureDate.format("Y-MM-DD") <
            analyseDate.format("Y-12-31")
          ? "attentionWorkingDates"
          : "attentionArrivalDate"
        : collaborator &&
          collaborator.departureDate &&
          typeof collaborator.departureDate === Date &&
          collaborator.departureDate.format("Y-MM-DD") <
            analyseDate.format("Y-12-31")
          ? "attentionDepartureDate"
          : null;

    return (
      <div style={{ width: "77%" }}>
        <div className="row medium-12">
          <div className={"medium-8"}>
            <div
              className={styles.title_bar}
              style={
                isCollaboratorAccess(loggedAs, spaceAs) ? { marginTop: 0 } : {}
              }
            >
              <div className={styles.title_bar_title}>
                <span>{collaborator && collaborator.name} </span>
                {_("fromDate")}{" "}
                {collaborator &&
                collaborator.arrivalDate &&
                collaborator.arrivalDate.format("Y-MM-DD") >
                  analyseDate.format("Y-01-01") ? (
                  <span>{collaborator.arrivalDate.format("DD-MM-Y")}</span>
                ) : (
                  <span>{analyseDate && analyseDate.format("01-01-Y")}</span>
                )}
                {_("toDate")}{" "}
                <span>{analyseDate && analyseDate.format("DD-MM-Y")}</span>
                {warningDate && (
                  <span className={styles.warning}>
                    <Tooltip
                      key={`arrivalDate`}
                      placement="top"
                      title={_(warningDate)}
                    >
                      <TiWarningOutline />
                    </Tooltip>
                  </span>
                )}
              </div>
              <Button
                key="filter"
                style={{
                  height: 26,
                  width: 36,
                  padding: 0,
                  marginLeft: 5,
                  alignItems: "center",
                  color: "white",
                  background: "#6D7F92",
                  display: "flex",
                  textAlign: "center",
                  justifyContent: "space-around",
                  border: "1px solid rgba(109, 127, 146, 0.2)",
                  boxSizing: "border-box",
                  borderRadius: "30px",
                  boxShadow: "0px 4px 4px rgba(41, 57, 77, 0.05)"
                }}
                onClick={() => this.handleToogleFilter()}
              >
                <FilterIcon className={styles.icon_filter} />
              </Button>
              {filterFormIsVisible && (
                <div
                  ref={this.setFilterWrapperRef.bind(this)}
                  className={styles.filter_frame}
                >
                  {(isManagerAccess(loggedAs, spaceAs) ||
                    isAdminAccess(loggedAs, spaceAs) ||
                    isSuperAdminAccess(loggedAs, spaceAs)) && (
                    <div
                      id="collaborator-select"
                      className={styles.filter_frame_field}
                    >
                      <span className="lbl">{_("collaborator")}</span>
                      <Select
                        isMulti={false}
                        isSearchable={false}
                        isClearable={false}
                        closeMenuOnSelect
                        placeholder={"collaborator"}
                        options={this.state.collaborators}
                        value={
                          this.state.collaborators.length > 0 &&
                          this.state.collaborators.find(
                            obj => obj.value === parseInt(collaborator.id, 10)
                          )
                        }
                        onChange={this.handleCollaboratorChange}
                        className={styles.filter_frame_field_placeholder}
                      />
                    </div>
                  )}
                  <div
                    id="single-date-picker"
                    className={styles.filter_frame_field}
                  >
                    <span className="lbl">{_("analyseDate")}</span>
                    <SingleDatePicker
                      id="your_unique_id"
                      isOutsideRange={day =>
                        day.isAfter(this.props.lastDate) ||
                        (collaborator.arrivalDate &&
                          day.isBefore(collaborator.arrivalDate))
                      }
                      date={analyseDate}
                      displayFormat={() => "DD/MM/YYYY"}
                      onDateChange={this.handleChangeFilterDate}
                      focused={this.state.focused}
                      onFocusChange={({ focused }) =>
                        this.setState({ focused })
                      }
                      numberOfMonths={1}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="medium-4">
            {(isManagerAccess(loggedAs, spaceAs) ||
              isAdminAccess(loggedAs, spaceAs) ||
              isSuperAdminAccess(loggedAs, spaceAs)) && (
              <div style={{ marginLeft: "27%" }}>
                <button
                  style={{ width: "227px" }}
                  className="btn secondary text-uppercase"
                  onClick={() =>
                    this.handleRedirectCollaboratorCapacityPlaning(
                      collaborator.id,
                      collaborator.name
                    )
                  }
                >
                  <SvgIcon icon={ICONS.FINANCIAL_PAGE_ICON} />
                  {_("capacityPlaning")}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  handleRedirectBack = () => {
    this.props.dispatch(goBack());
  };

  handleRedirectCollaboratorCapacityPlaning = (id, name) => {
    this.props.dispatch(
      setFilterCollaborators([{ value: id, label: name, color: "#000000" }])
    );
    this.props.dispatch(push("/calendar/" + name + "/" + id));
  };

  handleClickOutsideCollaboratorFilter(event) {
    if (
      this.wrapperFilterRef &&
      !this.wrapperFilterRef.contains(event.target)
    ) {
      this.setState({ filterFormIsVisible: false });
    }
  }

  setFilterWrapperRef(node) {
    this.wrapperFilterRef = node;
  }

  handleToogleFilter = () => {
    this.setState(state => {
      return {
        filterFormIsVisible: !state.filterFormIsVisible
      };
    });
  };

  handleCollaboratorChange = selected => {
    this.props.dispatch(
      setCapacityPlaningCollaborator({
        id: selected.value,
        name: selected.label
      })
    );
    this.props.dispatch(
      push(`/capacity-planing/collaborator/${selected.label}/${selected.value}`)
    );
  };

  handleChangeFilterDate = date => {
    this.setState({ analyseDate: date });
  };

  handleAnalyseDateChange = (date, year) => {
    date && this.setState({ analyseDate: date });
    if (year) {
      let newDate =
        moment()
          .year()
          .toString() === year.toString()
          ? moment()
          : new moment(year + "-12-31");
      this.setState({ analyseDate: newDate });
    }
  };

  // Tabs functions
  selectTab = activeTab => {
    const { dispatch } = this.props;
    dispatch(setCapacityPlaningCollaboratorTab(activeTab));
  };

  handleActivateArrowLeft = () => {
    const { arrowPosition } = this.state;
    this.setState({
      arrowPosition: arrowPosition - 4 >= 0 ? arrowPosition - 4 : 0
    });
  };

  handleActivateArrowRight = () => {
    const { lengthItems, arrowPosition } = this.state;
    this.setState({
      arrowPosition:
        lengthItems - arrowPosition - 4 >= 4
          ? arrowPosition + 4
          : lengthItems - arrowPosition - 4
    });
  };

  handleArrowRightAndLeft = () => {
    const { arrowPosition, lengthItems } = this.state;
    this.setState({
      lengthItems: tabs.length
    });
    this.setState({
      arrowLeft: arrowPosition === 0 ? false : true,
      arrowRight: lengthItems - arrowPosition <= 4 ? false : true
    });
  };

  render() {
    const { activeTab, dispatch, collaboratorCapacityPlanning } = this.props;
    let {
      loadingCollaborators,
      loadingCollaborator,
      fetchedCollaborator,
      collaborator,
      analyseDate
    } = this.state;
    let fetching = loadingCollaborator || loadingCollaborators;

    return (
      <div
        className={classnames(
          "ttp-tab-container",
          activeTab !== "MODEL_ALL_CLIENTS" && styles.override_padding
        )}
        style={{ padding: activeTab === "MODEL_ALL_CLIENTS" && 0 }}
      >
        {/* <SettingPageHeader
          title={_("detailedBudget")}
          onBack={
            isManagerAccess(loggedAs, spaceAs)
              ? () => this.handleRedirectBack()
              : null
          }
          customAddOn={this.renderCapacityPlanningTitle()}
        /> */}
        <div className={styles.resizable}>
          {/***************  capacityPlanning viewer body *************/}
          <div>
            <div>
              {/* {!fetching && (
                <div className={styles.tab_bar}>
                  <TTPTab
                    tabs={tabs}
                    activeTab={activeTab}
                    selectTab={this.selectTab}
                    handleActivateArrowLeft={this.handleActivateArrowLeft}
                    handleActivateArrowRight={this.handleActivateArrowRight}
                    arrowLeft={this.state.arrowLeft}
                    arrowRight={this.state.arrowRight}
                  />
                </div>
              )} */}
              <div>
                <div>
                  {fetching || !collaboratorCapacityPlanning ? (
                    <div className={styles.ripple_loading}>
                      <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                    </div>
                  ) : activeTab === "COLLABORATOR_SPACE" ? (
                    <CollaboratorSpace
                      date={analyseDate}
                      from={"MANAGER_VIEW"}
                      collaborator={collaborator}
                      onAnalyseDateChange={this.handleAnalyseDateChange}
                    />
                  ) : activeTab === "CALENDAR" ? (
                    <CollaboratorCalendarContainer
                      date={analyseDate}
                      arrivalDate={collaborator && collaborator.arrivalDate}
                      onAnalyseDateChange={this.handleAnalyseDateChange}
                    />
                  ) : activeTab === "FINANCIAL" ? (
                    <CapacityPlaningCollaboratorFinancials
                      date={analyseDate}
                      dispatch={dispatch}
                      collaborator={collaborator}
                      arrivalDate={collaborator && collaborator.arrivalDate}
                      onAnalyseDateChange={this.handleAnalyseDateChange}
                    />
                  ) : activeTab === "MODEL_ALL_CLIENTS" ? (
                    fetchedCollaborator && (
                      <GroupedCapacityPlaningClients
                        date={analyseDate}
                        arrivalDate={collaborator.arrivalDate}
                        onAnalyseDateChange={this.handleAnalyseDateChange}
                        collaboratorName={collaborator && collaborator.name}
                      />
                    )
                  ) : (
                    <NotFoundV2 />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activeTab: state.capacityPlaning.collaborator.tab,
  collaboratorCapacityPlanning: state.capacityPlaning.collaborator.collaborator,
  lastDate: state.capacityPlaning.collaborator.filter.lastDate,
  organization: state.auth.currentOrganization,
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth.spaceAs,
  lng: state.params.lng
});

export default connect(mapStateToProps)(CapacityPlaningCollaborator);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CapacityPlaningCollaborator.js